module.exports = __webpack_public_path__ + "img/HT01077-01.f2218102.jpg";